export class UserFilter{
	name?: string;
	lastname?: string;
	email?: string;
	group?: string;
	role?: string;
}

export class OrderFilter{
	product?: string;
  name?: string;
  ident?: string;
	dateStart?: string;
	dateEnd?: string;
	shop?: string;
	state?: string;
}

export class RatingFilter{
	start?: number;
	length?: number;
	dateStart?: string;
	dateEnd?: string;
	state?: string;
}

export class StatFilter{
	start?: string;
	end?: string;
}

export class ProductFilter{
	name?: string;
	fullname?: string;
	categ?: string;
	scateg?: string;
	gamme?: string;
	marque?: string;
	tag?: string;
	banner?: string;
  dateEnd?: string;
	priceMin?: number=1;
	priceMax?: number=500;
	yearMin?: number;
	yearMax?: number;
	dMin: number;
	dMax: number;
	pMin: number;
	pMax: number;
	news: boolean;
	promo: boolean;
  used: boolean;
  statutStart: string;
  statutEnd: string;
  instock: boolean;
  lowstock: boolean;
  scoring: boolean;
  sort: { createdAt: number; };

/**
 * Constructor
 * @param {string} [type] name, categ, scateg, gamme, marque, tag or banner
 * @param {string} [val] value for the given type
 */
	constructor(type?: string, val?: string){
		switch(type){
			case 'name':
				this.name=val;
				break;
			case 'categ':
				this.categ=val;
				break;
			case 'scateg':
				this.scateg=val;
				break;
			case 'gamme':
				this.gamme=val;
				break;
			case 'marque':
				this.marque=val;
				break;
        case 'tag':
          this.tag=val;
          break;
        case 'banner':
          this.banner=val;
          break;
        case 'news':
          this.news=true;
      		break;
        case 'promos':
          this.promo=true;
      		break;
        case 'used':
          this.used=true;
      		break;
        case 'instock':
          this.instock=true;
          break;
        case 'lowstock':
          this.lowstock=true;
          break;
			default:
				break;
		}
	}
}
